<template>
  <div class="q-pa-xl text-center">
    {{ $t('qrCodeScanner.scanHint') }}
  </div>
  <qr-stream @decode="onDecode"></qr-stream>
</template>

<script>
import { QrStream } from 'vue3-qr-reader';

export default {
  name: 'QRCodeScanner',
  components: {
    QrStream,
  },
  emits: ['decode'],
  methods: {
    onDecode(decode) {
      console.log(decode);
      this.$emit('decode', decode);
    },
  },
};
</script>
